<fgb-account-layout titleKey="rovers.ticketing.network" titleDefault="Member Network">
  <fgb-account-panel titleKey="rovers.ticketing.network" titleDefault="Member Network">
    <div class="d-flex flex-lg-row flex-column justify-content-center fgb-member-network text-white">
      <div class="fgb-member-network-content w-100">
        <h5 class="fgb-member-network-content-heading">{{ 'fgb.member.network.content.heading' | translate }}</h5>
        <div
          class="fgb-member-network-content-description"
          [innerHTML]="'fgb.member.network.content.description' | translate | markdownTranslate"
        ></div>
        <div class="fgb-member-network-content-btn-div d-flex justify-content-end">
          <a
            class="btn btn-secondary fgb-member-network-content-btn text-white d-flex align-items-center justify-content-center"
            [href]="'fgb.member.network.ticket.master.link' | translate"
          >
            <span class="font-size-14 fw-bold">{{ 'fgb.member.network.content.btn' | translate }}</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Start Network Member List -->
    <div class="fgb-member-network-list-div mt-4">
      <ng-container *ngIf="networkMembers$ | async as networkMembers">
        <div class="d-flex align-items-center">
          <h5 class="fgb-member-network-list-heading me-1">{{ 'fgb.member.network.list.heading' | translate }}</h5>
          <h5 class="text-info fw-bold font-size-16">({{ networkMembers.length }})</h5>
        </div>
        <div class="fgb-member-network-list-description font-size-14 mb-3">
          {{ 'fgb.member.network.list.description' | translate }}
        </div>
        <ng-container *ngIf="networkMembers.length > 0; else noNetworkMember">
          <ng-container *ngFor="let networkMember of networkMembers">
            <div class="d-lg-flex d-none">
              <div class="row align-items-center justify-content-between bg-white fgb-member-network-list mx-0 w-100">
                <div class="col-3 font-size-14 fw-bold fgb-member-network-list-item-name">
                  {{ networkMember.FirstName }} {{ networkMember.Surname }}
                </div>
                <div class="col-2 fgb-member-network-list-item-id">
                  <span class="fw-bold me-2 font-size-12">
                    {{ 'fgb.member.network.list.id' | translate }}
                  </span>
                  <span class="font-size-14">
                    {{ networkMember.ExternalRefNumber }}
                  </span>
                </div>
                <div class="col-2 fgb-member-network-list-item-tier-points">
                  <span class="fw-bold me-2 font-size-12">
                    {{ 'fgb.member.network.list.tier.points' | translate }}
                  </span>
                  <span class="font-size-14">
                    {{ networkMember.TierPoints }}
                  </span>
                </div>
                <div class="col-4 fgb-member-network-list-item-balance">
                  <span class="fw-bold me-2 font-size-12">
                    {{ 'fgb.member.network.list.balance' | translate }}
                  </span>
                  <span class="font-size-14">
                    {{ networkMember.CashBack | FortressCurrencyPipe }}
                  </span>
                </div>
              </div>
            </div>
            <div class="d-lg-none d-flex">
              <div class="bg-white fgb-member-network-list w-100 px-3">
                <div class="d-flex align-items-center justify-content-between border-bottom border-disabled pb-2">
                  <div class="font-size-14 fw-bold fgb-member-network-list-item-name">
                    {{ networkMember.FirstName }} {{ networkMember.Surname }}
                  </div>
                </div>
                <div class="row align-items-center justify-content-between mt-2">
                  <div class="col-6 fgb-member-network-list-item-id">
                    <span class="fw-bold me-2 font-size-12">
                      {{ 'fgb.member.network.list.id' | translate }}
                    </span>
                    <span class="font-size-14">
                      {{ networkMember.ExternalRefNumber }}
                    </span>
                  </div>
                  <div class="col-6 fgb-member-network-list-item-tier-points text-end">
                    <span class="fw-bold me-2 font-size-12">
                      {{ 'fgb.member.network.list.tier.points' | translate }}
                    </span>
                    <span class="font-size-14">
                      {{ networkMember.TierPoints }}
                    </span>
                  </div>
                </div>
                <div class="row align-items-center justify-content-between mt-2">
                  <div class="col-6 fgb-member-network-list-item-balance">
                    <span class="fw-bold me-2 font-size-12">
                      {{ 'fgb.member.network.list.balance' | translate }}
                    </span>
                    <span class="font-size-14">
                      {{ networkMember.CashBack | FortressCurrencyPipe }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #noNetworkMember>
        <div class="no-items w-100 text-center py-3 rounded-4 bg-white border border-disabled">
          <div class="no-results-placeholder-text text-info">{{ 'member.network.placeholder.description' | translate }}</div>
        </div>
      </ng-template>
    </div>
    <!-- End Network Member List -->
  </fgb-account-panel>
</fgb-account-layout>
